import { createAction, createReducer } from "redux-act";

export const loginUser: any = createAction("login");
export const logoutUser: any = createAction("logout");

export const setSchool: any = createAction("user - change school");

export interface IUserLoginPayload {
  loggedIn: boolean;
  user: any;
  schools: any;
  selectedSchool: any;
}

export default createReducer({
    [loginUser]: (state: any, payload: IUserLoginPayload) => {
      return {
        ...state, 
        loggedIn: payload.loggedIn,
        user: payload.user,
        schools: payload.schools,
        selectedSchool: payload.selectedSchool
      };
    },
    [logoutUser]: (state) => {
      return {
        ...state, 
        loggedIn: false,
        user: {},
        schools: [],
        selectedSchool: {}
      };
    },
    [setSchool]: (state, payload) => {
      return {
        ...state, 
        selectedSchool: payload
      };
    },
  }, {
    loggedIn: false,
    user: {},
    schools: [],
    selectedSchool: {}
});